const translations = {
  "en": {
    "If Ed's helped you get a clearer handle on your money, a quick rating helps more people find us.": "If Ed's helped you get a clearer handle on your money, a quick rating helps more people find us.",
    "Satisfied with Ed?": "Satisfied with Ed?",
    "Satisfied with Edgen?": "Satisfied with Ed?",
    "Share your 5-star rating to help us keep identifying HK & US profit opportunities for you.": "Share your 5-star rating to help us keep identifying HK & US profit opportunities for you."
  },
  "zh-tw": {
    "If Ed's helped you get a clearer handle on your money, a quick rating helps more people find us.": "若 Ed 協助您更清晰掌握資金狀況，請給予快速評分，讓更多投資人認識我們。",
    "Satisfied with Ed?": "您對 Ed 滿意嗎？",
    "Satisfied with Edgen?": "對 Ed 感到滿意嗎？",
    "Share your 5-star rating to help us keep identifying HK & US profit opportunities for you.": "分享你的五星評價給我們，幫助我們持續為你發掘港美股的獲利機會。"
  }
};

export default translations;
